












import { Component, Vue, Prop } from 'vue-property-decorator';

@Component({})
export default class IsRestrictedBlock extends Vue {
  @Prop(String)
  private readonly borderColor?: string;

  @Prop(String)
  private readonly borderRadius?: string;

  @Prop(String)
  private readonly padding?: string;
}
